export default __webpack_public_path__ + "static/media/group-selected-icon.853dee70.svg";